export enum AlertStyle {
    success,
    warning,
    error,
    general,
    info
}

export enum AlertColourScheme {
    green,
    orange,
    red,
    grey,
    blue
}